import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const intersectAsync = (first, second, comparer) => {
    async function* iterator() {
        const firstResults = await first.distinctAsync(comparer).toArray();
        if (firstResults.length === 0) {
            return;
        }
        const secondResults = await second.toArray();
        for (let i = 0; i < firstResults.length; i++) {
            const firstValue = firstResults[i];
            for (let j = 0; j < secondResults.length; j++) {
                const secondValue = secondResults[j];
                if (await comparer(firstValue, secondValue) === true) {
                    yield firstValue;
                    break;
                }
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
